import { render } from "./TherapyCard.vue?vue&type=template&id=8a79784e&scoped=true&ts=true"
import script from "./TherapyCard.vue?vue&type=script&lang=ts"
export * from "./TherapyCard.vue?vue&type=script&lang=ts"

import "./TherapyCard.vue?vue&type=style&index=0&id=8a79784e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a79784e"]])

export default __exports__